export default {
  knowledgeBase: 'AI知识库',
  knowledgeCorpus: '智能客服语料',
  agentEvaluation: '智能体评估',
  addAgentEvaluationData: '添加智能体评估数据',
  agentEvaluationModalDesc: '将当前已选反馈添加到已有数据集，或创建一个新的评估数据集。',
  agentEvaluationAddExisting: '添加到已有数据集',
  agentEvaluationCreateDataset: '创建新数据集',
  agentEvaluationConfirmAdd: '确认添加',
  agentEvaluationSelectDataset: '请选择目标数据集',
  agentEvaluationDatasetName: '数据集名称',
  agentEvaluationDatasetNamePlaceholder: '请输入数据集名称',
  agentEvaluationSelectedCount: '当前已选 {val1} 条反馈',
  agentEvaluationSampleCount: '样本数：{val1}',
  agentEvaluationNoDataset: '暂无可用数据集，请切换到“创建新数据集”。',
  agentEvaluationAddSuccess:
    '已添加{val1}条反馈到数据集，跳过{val2}条重复反馈',
  agentEvaluationAddFailed: '添加智能体评估数据失败',
  agentEvaluationLoadFailed: '获取智能体评估数据集失败',
  agentEvaluationPleaseSelectFeedback: '请至少选择一条反馈',
  agentEvaluationEntryDesc:
    '用于沉淀反馈样本，后续可作为智能体评估输入数据集。',
  agentEvaluationGoFeedback: '前往反馈查询添加数据',
  agentEvaluationViewDetail: '查看数据集',
  agentEvaluationDeleteDatasetConfirm: '确定要删除数据集“{val1}”吗？',
  agentEvaluationDeleteSampleConfirm: '确定要删除反馈“{val1}”吗？',
  agentEvaluationDeleteDatasetSuccess: '数据集删除成功',
  agentEvaluationDeleteSampleSuccess: '样本删除成功',
  agentEvaluationDeleteFailed: '删除失败',
  agentEvaluationNoData: '暂无智能体评估数据',
  agentEvaluationBackList: '返回数据集列表',
  agentEvaluationPageTitle: '智能体评估',
  agentEvaluationSelectDatasetEmpty: '尚未选择数据集，请点击“选择数据集”后载入评估样例。',
  agentEvaluationSelectDatasetDesc: '请选择数据集后开始评估，数据集需先在反馈查询页创建。',
  agentEvaluationCurrentDatasetUnavailable: '最近使用的数据集不可用',
  agentEvaluationChooseDataset: '选择数据集',
  agentEvaluationSampleTitle: '评估样例',
  agentEvaluationCriteriaTitle: '评估标准和权重',
  agentEvaluationResultTitle: '评估结果',
  agentEvaluationCriteriaGenerate: '生成评估标准和权重',
  agentEvaluationCriteriaSave: '保存',
  agentEvaluationStart: '开始评估',
  agentEvaluationBackEdit: '返回编辑',
  agentEvaluationSharedMode: '共用评估标准',
  agentEvaluationSharedModeDesc: '本轮次所有样例使用同一套评估标准和权重',
  agentEvaluationPerSampleMode: '每个样例独立评估标准',
  agentEvaluationPerSampleModeDesc: '为每个反馈样例单独生成和维护评估标准',
  agentEvaluationSelectModeFirst: '请先选择评估标准类型',
  agentEvaluationGenerateEmpty: '暂无评估标准，可生成或手动添加评估标准。',
  agentEvaluationModeEmpty: '请选择评估标准类型后再生成评估标准。',
  agentEvaluationCriteriaSaved: '评估标准和权重已保存',
  agentEvaluationCriteriaGenerated: '评估标准和权重生成成功',
  agentEvaluationCriteriaGenerateFailed: '生成评估标准和权重失败',
  agentEvaluationCriteriaGenerateTimeout: '评估标准生成超时，请稍后重试',
  agentEvaluationCriteriaSaveFailed: '保存评估标准和权重失败',
  agentEvaluationCriteriaResetOnModeChange: '尚未选择数据集，已清空当前编辑的评估标准',
  agentEvaluationNeedDataset: '请先选择评估数据集',
  agentEvaluationNeedCriteria: '请先生成或完善评估标准',
  agentEvaluationResultWaiting: '选择数据集并开始评估后，这里会展示总体评估建议和每个样例的明细结果。',
  agentEvaluationResultPending: '等待开始评估',
  agentEvaluationResultEvaluating: '评估中...',
  agentEvaluationAverageScore: '平均得分',
  agentEvaluationRunSuccess: '智能体评估完成',
  agentEvaluationRunFailed: '智能体评估失败',
  agentEvaluationRunTimeout: '评估超时，请稍后查看历史评估结果',
  agentEvaluationCriteriaColumn: '评估标准',
  agentEvaluationWeightColumn: '评估权重',
  agentEvaluationCriteriaColumnTooltip:
    '一段需要满足的规则描述，例如：回答中包含json',
  agentEvaluationWeightColumnTooltip: '只能输入0到2之间的数',
  agentEvaluationSampleTabPrefix: '样例',
  agentEvaluationNoDatasetInModal: '当前还没有评估数据集，请先到反馈查询页创建。',
  agentEvaluationManageDataset: '管理数据集',
  agentEvaluationGoCreateDataset: '去反馈查询页创建数据集',
  agentEvaluationCreateDatasetGuide:
    '创建数据集方式：反馈查询页->勾选反馈->更多操作->添加智能体评估数据',
  agentEvaluationUseDataset: '使用数据集',
  agentEvaluationDatasetLoaded: '已载入数据集：{val1}',
  agentEvaluationSummaryTotal: '共 {val1} 个样例',
  agentEvaluationSummarySuccess: '成功 {val1} 个',
  agentEvaluationSummaryFailed: '失败 {val1} 个',
  agentEvaluationAddCriteria: '添加评估标准',
  agentEvaluationDeleteCriteria: '删除评估标准',
  agentEvaluationExpandResult: '展开评估结果',
  agentEvaluationCollapseResult: '收起评估结果',
  agentEvaluationExpandFailedReason: '展开失败原因',
  agentEvaluationCollapseFailedReason: '收起失败原因',
  agentEvaluationHistoryButton: '历史评估结果',
  agentEvaluationHistoryEmpty: '暂无历史评估记录',
  agentEvaluationHistoryLoadFailed: '获取历史评估记录失败',
  agentEvaluationHistoryDetailFailed: '获取历史评估结果失败',
  agentEvaluationHistorySequence: '第{val1}次评估',
  agentEvaluationHistoryDatasetLabel: '数据集：{val1}',
  knowledgeCorpusDesc: '知识库内容将作为背景知识，用于优化智能客服的回复效果和智能回复的推荐效果',
  addKnowledgeBase: '新增知识库',
  document: '文档',
  table: '表格',
  lastModifiedTime: '更新时间',
  lastUpdateTime: '最新发布',
  lastPublishTime: '最新发布时间',
  referenceCount: '引用数',
  count: '次',
  resolutionRate: '解决率',
  referenceCountTips: '知识库内语料匹配到用户提问的次数',
  resolutionRateTips: '知识库内语料解决用户问题的会话数/使用到该知识库的会话数',
  knowledgeBaseName: '知识库名称',
  pleaseEnterTheName: '请输入知识库名称',
  description: '知识库描述',
  pleaseEnterTheDescription: '请添加知识库描述',
  noDescription: '暂无描述',
  importFormatTips: '目前仅支持表格类型知识库，后续会支持导入iwiki等功能',
  determine: '创建并导入',
  cancel: '取消',
  format: '知识库格式',
  tableDescriptionTips: '适用于结构化问答数据',
  tableFormat: '表格格式',
  firstImportType: '首次导入类型',
  supportXlsxLocalFile: '支持xlsx格式的本地文件',
  importTable: '导入表格',
  upload: '上传',
  preview: '预览',
  nextStep: '下一步',
  previousStep: '上一步',
  import: '导入',
  clickToUpload: '点击或拖拽上传表格文件（.xlsx）',
  uploadFailed: '上传失败!',
  parseFailed: '表格解析失败，请检查格式或内容是否正确!',
  question: '问题',
  answer: '答案',
  datasourceTips: '共{val1}条数据',
  documentParsingRecord: '文档解析记录',
  total: '共{val1}条',
  hitCount: '近7天引用',
  likeCount: '近7天赞踩',
  enabled: '启用',
  createTime: '创建时间',
  creator: '创建人',
  created: '创建',
  operation: '操作',
  edit: '编辑',
  delete: '删除',
  questionName: '问题名称',
  pleaseEnterFi: '请输入{val1}',
  status: '状态',
  disabled: '禁用',
  allStatuses: '全部状态',
  confirmDeletion: '确认删除',
  confirmDeletion2: '确定要删除知识库"{val1}"吗？',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  createFailed: '创建失败',
  createKBSuccess: '知识库创建成功',
  createKBFailed: '知识库创建失败',
  editCorpus: '编辑语料',
  createCorpus: '创建语料',
  search: '查询',
  neverExpire: '永不失效',
  whenSelectingFailure: '选择失效日期',
  expireType: '失效日期',
  selectDate: '选择日期',
  pleaseSelectExpireDate: '请选择失效日期',
  atMost: '最多{val1}个字符',
  editFailed: '编辑失败',
  editSuccess: '编辑成功',
  titleCannotBeEmpty: '标题不能为空',
  createSuccess: '创建成功',
  repeatedContent: '语料内容重复',
  setFaqStatusSuccess: '操作成功',
  confirmDeleteCorpus: '删除后将无法恢复，请谨慎操作。',
  aiCorpusRecommend: 'AI客服语料推荐',
  aiCorpusRecommendInfo: '基于近期会话，生成的智能客服语料推荐。',
  aiCorpusRecommendDesc: '根据会话数据生成推荐，添加后会更新到智能客服的默认知识库内',
  selectAll: '全选',
  batchIgnore: '批量忽略',
  batchAdd: '批量添加',
  ignore: '忽略',
  add: '添加',
  noRecommendCorpus: '定期根据会话数据生成，目前暂无推荐语料',
  loading: '加载中...',
  recommendTime: '推荐时间',
  similarConversation: '相似会话',
  similarConversationCount: '{val1}次相似会话',
  viewAllInFeedbackSearch: '在反馈查询中查看全部{val1}条',
  index: '索引',
  addSuccess: '语料已成功添加至默认知识库',
  addFailed: '添加失败',
  ignoreSuccess: '忽略成功',
  ignoreFailed: '忽略失败',
  clearFilters: '清空筛选',
  importSuccessful: '导入完成，本次新增{val1}条数据',
  ignoreMessage: '，跳过{val1}条数据',
  resultModalTitle: '导入结果',
  resultModalDuplicateTip: '以下数据和现有知识库数据重复，暂不支持导入',
  gotIt: '我知道了',
  referencedKB: '引用知识库',
  notice: '提醒',
  publishCorpus: '发布到智能客服',
  publishCorpusConfirm: '本次改动{val1}条语料，是否将本次更新内容发布到智能客服？',
  unsyncedChangesCount: '条改动未发布',
  unpublishedLeaveTip: '当前存在未发布到智能客服的改动，确定要离开吗？',
  publishSuccessful: '发布成功！{val1}条语料已发布',
  syncToFaq: '同步到FAQ管理',
  syncToFaqDesc: '新问题默认分组且用户不可见；已有问题只更新内容',
  goToSmartCustomer: '前往智能客服',
  batchFillTip: '想给已选的{val1}条问题填同一个答案？',
  expand: '展开',
  collapse: '收起',
  batchFillPlaceholder: '请输入答案内容，将填充到所有已选中的条目中',
  batchFillButton: '一键填充（{val1}条已选）',
  emptyAnswerConfirm: '当前选中的条目中有{val1}条答案为空，确认添加吗？',
  confirmAdd: '确认添加',
  cancelText: '取消',
  smartClassification: '智能分类',
  modelListTab: '模型列表',
  operationRecordTab: '操作记录',
  confirmEnableTitle: '确认操作',
  confirmEnableContent: '确认启用{val1}',
  confirmEnableDetail: '仅对后续新增反馈生效，历史数据分类不变',
  v2MigrationTip:
    '此项目已切换为智能分类2.0，请通过 知识库-智能分类 编辑',
  goToSmartClassification: '前往知识库-智能分类',
  operationMatter: '操作事项',
  operationFields: '操作字段',
  modelID: '模型ID',
  operator: '操作人',
  operateTime: '操作时间',
  modelDescriptionEmpty: '暂无模型描述，点击此处补充',
  modelInfoNotFound: '未找到该模型的基础信息。',
  modelNameRequired: '模型名称不能为空',
  editModelName: '编辑模型名称',
  editModelDescription: '编辑模型描述',
  saveWithEnter: '保存（Enter）',
  cancelWithEsc: '取消（Esc）',
  publishModel: '发布模型',
  confirmPublish: '确认发布',
  publishingModel: '发布中…',
  publishingTooltip: '正在发布中，请稍候…',
  publishDraftTooltip: '将当前草稿配置发布上线',
  modelPublishSuccess: '模型发布成功',
  modelPublishFailed: '模型发布失败，请稍后重试',
  publishingModelTitle: '正在发布模型，请耐心等待…',
  publishingModelHint: '发布会同步草稿配置到线上版本，过程可能需要数分钟。',
  elapsedTime: '已耗时 {val1}',
  publishingDoNotClose:
    '请勿关闭页面或刷新浏览器，否则可能导致发布状态不一致。',
  publishModelConfirmPrefix: '你即将发布模型',
  currentModel: '当前模型',
  publishModelConfirmSuffix:
    '，发布后会将以下内容由「草稿」覆盖到「线上版本」：',
  publishImpactTree: '当前分类树的全部节点',
  publishImpactRules: '已启用的所有分类规则',
  publishImpactModelConfig: '模型的基础配置（名称 / 描述等）',
  publishModelWarning:
    '发布过程可能需要数分钟且不可中断，请确认当前所有改动均已校对无误后再继续。',
};
